import React from "react";
import { Box, Table } from "@mui/joy";
import JSONPretty from 'react-json-pretty'
import { useFormContext } from "react-hook-form"

const WidgetPreviewExcelData = ({ className }) => {

    const { getValues } = useFormContext();
    const data = getValues('excelData');

    return (
        <Box className={"form-element importer-data "+className} sx={{overflow:'hidden'}}>
            {data &&
                <Table>
                    <thead>
                        <tr className="sourceHead">
                            {
                                Object.keys(data[0]).map((key) => (
                                    <th key={key} title={key}>{key}</th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((item, rowid) => (
                                <tr key={rowid}>
                                    {
                                        Object.keys(item).map((key) => (
                                            <td key={key} title={item[key]}>{item[key]}</td>
                                        ))
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            }
        </Box>
    );
};

export default WidgetPreviewExcelData;